import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BL } from 'src/environments/environment';
import { ConfigService } from '../config/config.service';
import { Airports } from 'src/app/flight/models/Airport';
import { FlightResponse } from 'src/app/flight/models/FlightResponse';
import { NewTicketRequest } from 'src/app/flight/models/NewTicketRequest';
import { NewTicketResponse } from 'src/app/flight/models/NewTicketResponse';
import { TicketsResponse } from 'src/app/flight/models/Ticket';
import { CancelTicketRequest } from 'src/app/flight/models/CancelTicketRequest';
import { DefaultResponse } from 'src/app/models/DefaultResponse';
import { OTAAirScheduleResponse } from 'src/app/flight/models/OTAAirScheduleResponse';
import { SeatCountResponse } from 'src/app/flight/models/SeatCountResponse';
import { FlightCrewSummaryResponse } from 'src/app/flight/models/FlightCrewItem';
import { CrewRouteItem } from 'src/app/flight/models/CrewRouteItem';

@Injectable({
  providedIn: 'root'
})
export abstract class PasseLivreService {

  protected API_URL: string;

  constructor(protected http: HttpClient, protected configService: ConfigService) {
    this.API_URL = BL.protocol + this.configService.settings.base_href;
  }


  abstract newTicket(newTicketRequest: NewTicketRequest): Observable<NewTicketResponse>;

  abstract getFlightsWithConex(dateFlight: string, dateTimeClient: string, origin: string, destination: string):Observable<any>;

  getTickets(status: string): Observable<TicketsResponse> {
    return this.http.get<TicketsResponse>(`${this.API_URL}${BL.getTickets}?status=${status}`);
  }

  getAirportsBr(): Observable<Airports> {
    return this.http.get<Airports>(`${this.API_URL}${BL.getAirportsBr}`);
  }

  cancelTicket(cancelTicketRequest: CancelTicketRequest): Observable<DefaultResponse> {
    return this.http.put<DefaultResponse>(`${this.API_URL}${BL.cancelTicket}`, cancelTicketRequest);
  }

  getSeatCounts(segments: Array<{ flightNumber: string; origin: string; departureDate: string }>): Observable<SeatCountResponse> {
    return this.http.post<SeatCountResponse>(`${this.API_URL}${BL.getSeatCounts}`, { flights: segments });
  }

  getFlightCrew(flightDate: string, flightNumber: string, departure: string): Observable<FlightCrewSummaryResponse> {
    return this.http.get<FlightCrewSummaryResponse>(`${this.API_URL}${BL.getFlightCrew}`, {
      params: { flightDate, flightNumber, departure }
    });
  }

  getTopRoutes(): Observable<CrewRouteItem[]> {
    return this.http.get<CrewRouteItem[]>(`${this.API_URL}${BL.getTopRoutes}`);
  }
}
